import CollisionDeductibles from "../../VehicleDropdowns/CollisionDeductibles"
import ComprehensiveDeductiblesDropdown from "../../VehicleDropdowns/ComprehensiveDeductibles"

const VehicleOwned_Coverages = ({ context, newVehicle, saveResponses }) => {

    return (
        <>
            {/* Other than Collision */}
            <div className="col-xl-12 mt-4">
                <div className="row form-group form-group-sm align-items-center">
                    <div className="col-xl-12 text-primary fw-bold">
                        Do you choose "Other than Collision" (Comprehensive) coverage? *
                        <a className="info-icon-for-select ms-2">
                            <i className="fa fa-question-circle"
                                onClick={() => {
                                    context.setValidationMsgToggle("\"Other than Collision\" (Comprehensive)",
                                        `"Other than Collision" (Comprehensive) covers your vehicle, and sometimes other vehicles you may be driving, 
                                        for losses resulting from incidents other than collision. For example, "Other than Collision" (Comprehensive) 
                                        insurance covers damage to your car if it is stolen, or damaged by flood, fire, or animals. It pays to fix your 
                                        vehicle less the deductible you choose. To keep your premiums low, select as high a deductible as you feel comfortable 
                                        paying out of pocket. Coverage is limited to the terms and conditions contained in the policy.`)
                                }}
                            />
                        </a>
                    </div>

                    {/* Other than Collision Coverage Response */}
                    <div className="col-xl-12">
                        {["1", "0"].map((value, id) => {
                            return (
                                <div className="radio-inline form-check form-check-inline mt-3" key={id}>
                                    <label className="form-check-label">
                                        <input type={"radio"} className="form-check-input" name={"otherThanCollision" + (newVehicle?.vehicleVIN) ? newVehicle?.vehicleVIN : newVehicle?.VIN}
                                            checked={newVehicle?.otherThanCollisionToggle == value ? newVehicle?.otherThanCollisionToggle : ""}
                                            value={value} onChange={(e) => saveResponses("otherThanCollisionToggle", e.target.value)}
                                        />{value == "1" ? "Yes" : "No"}
                                    </label>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {/* Other than Collision Deductible */}
            {newVehicle?.otherThanCollisionToggle == "1" &&
                <>
                    {/* Other than Collision Deductibles */}
                    <div className="col-xl-12 mb-3">
                        <div className="row form-group form-group-sm align-items-center">
                            <div className="col-xl-8 col-sm-4 col-md-8 text-primary fw-bold">
                                Choose your "Other than Collision" (Comprehensive) deductible. *
                            </div>

                            <div className="col-xl-4 col-sm-8 col-md-4">
                                <select className="col-sm-12 btn btn-default btn-group dropdown-toggle filter-option mt-1"
                                    value={newVehicle?.standardDeductibleComprehensive ? newVehicle?.standardDeductibleComprehensive : ""}
                                    onChange={(e) => saveResponses('standardDeductibleComprehensive', e.target.value)}
                                >
                                    {ComprehensiveDeductiblesDropdown()}
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Collision Coverage */}
                    <div className="col-xl-12 mt-4">
                        <div className="row form-group form-group-sm align-items-center">
                            <div className="col-xl-8 text-primary fw-bold">
                                Do you choose "Collision" coverage? *
                                <a className="info-icon-for-select ms-2">
                                    <i className="fa fa-question-circle"
                                        onClick={() => {
                                            context.setValidationMsgToggle("Collision Coverage",
                                                `Collision covers damage to your car when your car hits, or is hit by, another vehicle, or other object. This coverage 
                                                pays to fix your vehicle less the deductible you choose. To keep your premiums low, select as large a deductible 
                                                as you feel comfortable paying out of pocket. Coverage is limited to the terms and conditions contained in the policy.`)
                                        }}
                                    />
                                </a>
                            </div>

                            {/* Collision Coverage Response */}
                            <div className="col-xl-12">
                                {["1", "0"].map((value, id) => {
                                    return (
                                        <div className="radio-inline form-check form-check-inline mt-3" key={id}>
                                            <label className="form-check-label">
                                                <input type={"radio"} className="form-check-input" name="collisionCoverage"
                                                    checked={newVehicle?.collisionCoverageToggle == value ? newVehicle?.collisionCoverageToggle : ""}
                                                    value={value} onChange={(e) => { saveResponses("collisionCoverageToggle", e.target.value) }}
                                                />{value == "1" ? "Yes" : "No"}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Collision Coverage Questions */}
                    {newVehicle?.collisionCoverageToggle == "1" &&
                        <>
                            {/* Collision Types */}
                            <div className="col-xl-12 mb-3">
                                <div className="row form-group form-group-sm align-items-center">
                                    <div className="col-xl-8 col-sm-4 col-md-8 text-primary fw-bold">
                                        Choose your "Collision" type. *
                                        <a className="info-icon-for-select ms-2">
                                            <i className="fa fa-question-circle"
                                                onClick={() => {
                                                    context.setValidationMsgToggle("What are the options for Collision coverage?", collisionCoverages)
                                                }}
                                            />
                                        </a>
                                    </div>

                                    {/* Collision Types */}
                                    <div className="col-xl-4 col-sm-8 col-md-4">
                                        <select className="col-sm-12 btn btn-default btn-group dropdown-toggle filter-option mt-1"
                                            value={newVehicle?.collisionCoverageType ? newVehicle?.collisionCoverageType : ""}
                                            onChange={(e) => saveResponses('collisionCoverageType', e.target.value)}
                                        >
                                            <option value={""} disabled>Select…</option>
                                            <option value={"Standard"}>Standard</option>
                                            <option value={"Limited"}>Limited</option>
                                            <option value={"Broadened"}>Broadened</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Collision Coverage Deductible */}
                            <div className="col-xl-12 mb-4">
                                <div className="row form-group form-group-sm align-items-center">
                                    <div className="col-xl-8 col-sm-4 col-md-8 text-primary fw-bold">
                                        Choose your "Collision" coverage deductible. *
                                    </div>

                                    <div className="col-xl-4 col-sm-8 col-md-4">
                                        <select className="col-sm-12 btn btn-default btn-group dropdown-toggle filter-option mt-1"
                                            value={newVehicle?.standardDeductibleCollision ? newVehicle?.standardDeductibleCollision : ""}
                                            onChange={(e) => saveResponses('standardDeductibleCollision', e.target.value)}
                                        >
                                            {CollisionDeductibles(newVehicle?.collisionCoverageType)}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {/* Rental Reimbursement */}
                    <div className="col-xl-12 mb-3">
                        <div className="row form-group form-group-sm align-items-center">
                            <div className="col-xl-12 col-sm-6 col-md-8 text-primary fw-bold">
                                Rental Reimbursement *
                                <a className="info-icon-for-select ms-2">
                                    <i className="fa fa-question-circle"
                                        onClick={() => {
                                            context.setValidationMsgToggle("Rental Reimbursement",
                                                `Rental Reimbursement pays for the cost of a rental car if you can't drive the insured vehicle due to theft or damage 
                                                from an accident. Extended Transportation coverage cannot be purchased unless the car is covered under 'Other than Collision' 
                                                (Comprehensive) coverage. Coverage is limited to the terms and conditions contained in the policy.`)
                                        }}
                                    />
                                </a>
                            </div>

                            {/* Rental Reimbursement Response */}
                            <div className="col-xl-12 mt-3 text-muted">
                                <div className="radio-inline form-check form-check-inline col-12">
                                    <label className="form-check-label">
                                        <input type={"radio"} className="form-check-input" name="rentalReimbursement" value={'75043'}
                                            checked={(newVehicle?.rentalReimbursement == '75043')}
                                            onChange={(e) => { saveResponses("rentalReimbursement", e.target.value) }}
                                        />$40 per day/$1,200 max
                                    </label>
                                </div>
                                <div className="radio-inline form-check form-check-inline col-12">
                                    <label className="form-check-label">
                                        <input type={"radio"} className="form-check-input" name="rentalReimbursement" value={'71200'}
                                            checked={(newVehicle?.rentalReimbursement == '71200')}
                                            onChange={(e) => { saveResponses("rentalReimbursement", e.target.value) }}
                                        />$30 per day/$900 max
                                    </label>
                                </div>
                                <div className="radio-inline form-check form-check-inline col-12">
                                    <label className="form-check-label">
                                        <input type={"radio"} className="form-check-input" name="rentalReimbursement" value={'71000'}
                                            checked={(newVehicle?.rentalReimbursement === '71000')}
                                            onChange={(e) => { saveResponses("rentalReimbursement", e.target.value) }}
                                        />None
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

const collisionCoverages =
    <>
        <strong>Broad Collision</strong>: Pays for damages to your vehicle that was damaged regardless of fault, with a deductible that applies only if you are more than 50% at fault <br /><br />
        <strong>Standard Collision</strong>: Pays for damages to your vehicle that was caused regardless of fault, with a deductible that always applies. <br /><br />
        <strong>Limited Collision</strong>: Pays for damage to your vehicle if you are less than 50% at fault for an accident. If you are 50% or more at fault Collision coverage for this option will not apply to repair your vehicle.
    </>

export default VehicleOwned_Coverages